import { AbstractControl } from '@angular/forms';

export function CpfCnpjValidator(control: AbstractControl) {

  if (!control || !control.value) return null;

  const value = control.value.replace(/[^\d]+/g, '');

  // Valida Cpf

  if (value.length === 11) {
    return validateCPF(value) ? null : { cpfInvalid: true };
  }
  // Valida cnpj
  if (value.length === 14) {
    return validateCNPJ(value) ? null : { cnpjInvalid: true };
  }

  return { fieldInvalid: true };

}

export function CpfValidator(control: AbstractControl) {

  if (!control || !control.value) return null;

  const value = control.value.replace(/[^\d]+/g, '');
  return validateCPF(value) ? null : { cpfInvalid: true };
}

export function CnpjValidator(control: AbstractControl) {

  if (!control || !control.value) return null;

  const value = control.value.replace(/[^\d]+/g, '');
  return validateCNPJ(value) ? null : { cnpjInvalid: true };
}

function validateCNPJ(cnpj: string): boolean {

  let length: any = cnpj.length - 2;
  let numbers: any = cnpj.substring(0, length);

  const digits: any = cnpj.substring(length);

  let sum = 0;
  let pos = length - 7;

  for (let i = length; i >= 1; i--) {
    sum += numbers.charAt(length - i) * pos--;
    if (pos < 2) { pos = 9; }
  }

  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

  if (result !== digits.charAt(0) * 1) {
    return false;
  }

  length = length + 1;
  numbers = cnpj.substring(0, length);
  sum = 0;
  pos = length - 7;
  for (let i = length; i >= 1; i--) {
    sum += numbers.charAt(length - i) * pos--;
    if (pos < 2) {
      pos = 9;
    }
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

  return result === digits.charAt(1) * 1;
}

function validateCPF(cpf: any): boolean {

  if (cpf === '') { return false; }
  if (cpf.length !== 11) { return false; }

  return verifyDigit(cpf.substring(0, 9), cpf.charAt(9), 10) &&
         verifyDigit(cpf.substring(0, 10), cpf.charAt(10), 11);
}

function verifyDigit(
  digits:     number[],
  digit:      number,
  multiplier: number
): boolean {
  let sum = 0;

  for (let i = 0; i <= digits.length - 1; i++) {
    sum += (parseInt(digits[i].toString(), 32) * multiplier);
    multiplier--;
  }

  const remainder = (sum * 10 % 11) === 10 ? 0 : sum * 10 % 11;

  return remainder === parseInt(digit.toString(), 16);
}
